import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ChartPieIcon, LeftArrow } from '../../icons';
import { CustomModal } from '../ui';
import BookingStatics from './bookingStatics';
import { Rounded } from '../elements/rounded';

export const BookingPageTitle = () => {
  const navigate = useNavigate();

  const [openModal, setModalState] = useState(false);

  return (
    <div className="flex gap-x-2 justify-between">
      <div className="flex  max-lg:gap-x-6 items-center">
        <button className='lg:p-2' onClick={() => navigate('/dashboard')}>
          <LeftArrow width={32} height={32} />
        </button>
        <h2>Booking Reporting</h2>
      </div>
      <CustomModal
        triggerComponent={
          <div className="flex gap-2 py-3 lg:px-6 items-center">
            <span className="text-label max-lg:hidden">Booking Statistics</span>
            <Rounded className="bg-primary lg:w-6 lg:h-6 w-8 h-8 p-1 flex items-center justify-center">
              <ChartPieIcon className="w-8 h-8 lg:w-24 h-24" />
            </Rounded>
          </div>
        }
        wrapperClass="lg:max-h-[80vh] h-[100vh]"
        handleClick={setModalState}
        openModal={openModal}
      >
        <div className="lg:px-10 px-5 pt-5 lg:pt-[40px] lg:pb-7">
          <div className="flex flex-col items-center gap-3 l:gap-6">
            <h3 className="text-center">Booking Statistics</h3>
            <BookingStatics handleModalClose={() => setModalState(false)} />
          </div>
        </div>
      </CustomModal>
    </div>
  );
};
